import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  onlyLinkAprovationsAccess,
  onlyLinkProductsAccess,
  onlyLinkQuotesAccess,
  onlyLinkSimulatesAccess,
  showModulesAccess
} from "../Utils/onlyProductAccess";
import { Auth } from "aws-amplify";
import signOutIcon from "../Resources/svg/sign-out.svg";
import { logout } from "../Store/loginRedux/actions";
import { useHistory } from "react-router-dom";

import {
  cleanConfigProduct,
  cleanTablePdfRI,
  cleanTablePdf,
} from "../Store/secureInvestmentIncome/actions";
import { useDispatch, useSelector } from "react-redux";
import { cleanAdviser } from "../Store/adviser/actions";
import { storage } from "../Utils/storage";

const Panel = ({ active, closePanel }) => {
  const dispatch = useDispatch();
  const history = useHistory()
  const isLogin = useSelector((state) => state.login.granted);
  const modulesAccess = useSelector((state) => 
    (state.login.access_configuration && state.login.access_configuration.modules) || []
  );
  const idUser = useSelector((state) => state.login.idClient);

  const setValuesDynatrace = () => {
    if (window.dtrum) {
      window.dtrum.endSession();
    }

    if (isLogin) {
      window.idClient = idUser;
    }
  };

  useEffect(() => {
    setValuesDynatrace();
  }, [idUser]);

  const close = async () => {
    await dispatch(logout());
    await dispatch(cleanTablePdf());
    await dispatch(cleanTablePdfRI());
    await dispatch(cleanConfigProduct());
    await dispatch(cleanAdviser());
    storage().removeItem('jwt');
    history.push('/login');

    setTimeout(() => {
      signOut();
    }, 500);
  };

  const signOut = () => {
    window.open(process.env.REACT_APP_OAUTH2_LOGOUT);
    Auth.signOut({ global: true })
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <div className={`panel ${active ? "active" : ""}`}>
      {isLogin && (
        <>
          {showModulesAccess(modulesAccess, 'productos') && (
            <a href="/productos" className="panel__title">
              <p>Productos</p>
            </a>
          )}

          {showModulesAccess(modulesAccess, 'simulaciones') && (
            <a href="/simulaciones" className="panel__title">
              <p>Simulaciones</p>
            </a>
          )}

          {showModulesAccess(modulesAccess, 'cotizaciones') && (
            <a href="/cotizaciones" className="panel__title">
              <p>Cotizaciones</p>
            </a>
          )}

          {showModulesAccess(modulesAccess, 'aprobaciones') && (
            <a href="/aprobaciones" className="panel__title">
              <p>Aprobaciones</p>
            </a>
          )}

          {showModulesAccess(modulesAccess, 'configuraciones') && (
            <a href="/configuracion/AS" className="panel__title">
              <p>Configuración</p>
            </a>
          )}

          <div className="panel__title__block" onClick={close}>
            <img
              className="panel__title__block__img"
              src={signOutIcon}
              alt="signOut"
            />
            <p>Salir</p>
          </div>
        </>
      )}
    </div>
  );
};

export default withRouter(Panel);
